import React from 'react';

import { IconBase } from 'react-icons';

export type SavageIconTypes =
  | 'caretLeft'
  | 'caretRight'
  | 'caretUp'
  | 'caretDown'
  | 'close'
  | 'x'
  | 'cart'
  | 'heart'
  | 'email'
  | 'favorite'
  | 'burger'
  | 'arrowright'
  | 'tiktok'
  | 'youtube'
  | 'facebook'
  | 'instagram'
  | 'twitter'
  | 'pinterest'
  | 'person'
  | 'search'
  | 'star'
  | 'starOutline'
  | 'trashcan'
  | 'checkCircle'
  | 'chat'
  | 'chatAlt'
  | 'checkoutLoadingIndicator';

type Props = {
  // eslint-disable-next-line react/no-unused-prop-types
  size?: number | string;
  type: SavageIconTypes;
};

const VIEWBOX: Record<SavageIconTypes, string> = {
  caretLeft: '0 0 24 24',
  caretRight: '0 0 24 24',
  caretUp: '0 0 24 24',
  caretDown: '0 0 24 24',
  chat: '0 0 32 32',
  chatAlt: '0 0 32 32',
  checkCircle: '0 0 16 16',
  close: '0 0 24 24',
  x: '0 0 24 24',
  cart: '0 0 24 24',
  heart: '0 0 24 24',
  favorite: '0 0 24 24',
  burger: '0 0 24 24',
  arrowright: '0 0 24 24',
  tiktok: '0 0 24 24',
  youtube: '0 0 24 24',
  facebook: '0 0 24 24',
  instagram: '0 0 24 24',
  twitter: '0 0 24 24',
  pinterest: '0 0 24 24',
  person: '0 0 24 24',
  search: '0 0 13 13',
  star: '0 0 12 12',
  starOutline: '0 0 12 12',
  trashcan: '0 0 24 24',
  email: '0 0 32 32',
  checkoutLoadingIndicator: '0 0 120 120',
};

const EMPTY_PROPS = {};

const ADDITIONAL_PROPS = {
  starOutline: {
    fill: 'none',
  },
  x: {
    strokeWidth: 1,
  },
  close: {
    strokeWidth: 1,
  },
};

const Path = ({ type }: Props) => {
  switch (type) {
    case 'caretLeft':
      return (
        <path
          id="Vector"
          d="M14 17.3078L8.69225 12L14 6.69226L14.7078 7.40001L10.1078 12L14.7078 16.6L14 17.3078Z"
          fill="currentColor"
          stroke="currentColor"
        />
      );
    case 'caretRight':
      return (
        <path
          id="Vector"
          d="M13.2922 12L8.69225 7.40001L9.4 6.69226L14.7077 12L9.4 17.3078L8.69225 16.6L13.2922 12Z"
          fill="currentColor"
          stroke="currentColor"
        />
      );
    case 'caretUp':
      return (
        <path
          d="M6.39225 14.3L11.7 8.99225L17.0078 14.3L16.3 15.0077L11.7 10.4077L7.1 15.0077L6.39225 14.3Z"
          fill="currentColor"
          stroke="currentColor"
        />
      );
    case 'caretDown':
      return (
        <path
          d="M17.0078 9.7L11.7 15.0078L6.39225 9.7L7.1 8.99225L11.7 13.5923L16.3 8.99225L17.0078 9.7Z"
          fill="currentColor"
          stroke="currentColor"
        />
      );
    case 'chat':
    case 'chatAlt':
      return (
        <>
          <g clipPath="url(#clip0_22004_592)">
            <path
              d="M19.7002 7.82031H32.0195V23.2207H27.54V28.5879L26.7197 27.9043L21.0996 23.2207H12.46V19.0605H11.0527L5.11035 23.7529L4.30078 24.3916V19.0605H-0.179688V3.66016H19.7002V7.82031ZM19.7002 19.0605H13.46V22.2207H21.4609L21.5996 22.3359L26.54 26.4521V22.2207H31.0195V8.82031H19.7002V19.0605ZM0.820312 18.0605H5.30078V22.3271L10.5703 18.168L10.707 18.0605H18.7002V4.66016H0.820312V18.0605ZM6.08008 12.4805H4.48047V10.8799H6.08008V12.4805ZM10.2402 12.4805H8.63965V10.8799H10.2402V12.4805ZM14.4004 12.4805H12.7998V10.8799H14.4004V12.4805Z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id="clip0_22004_592">
              <rect width="32" height="32" fill="white" />
            </clipPath>
          </defs>
        </>
      );
    case 'checkCircle':
      return (
        <path
          d="M11.5123 5.71846C11.5695 5.77561 11.6149 5.84348 11.6459 5.91819C11.6769 5.9929 11.6928 6.07297 11.6928 6.15384C11.6928 6.23472 11.6769 6.31479 11.6459 6.3895C11.6149 6.46421 11.5695 6.53208 11.5123 6.58923L7.20462 10.8969C7.14746 10.9541 7.07959 10.9995 7.00489 11.0305C6.93018 11.0615 6.8501 11.0774 6.76923 11.0774C6.68836 11.0774 6.60828 11.0615 6.53358 11.0305C6.45887 10.9995 6.391 10.9541 6.33385 10.8969L4.48769 9.05077C4.37222 8.9353 4.30735 8.77868 4.30735 8.61538C4.30735 8.45208 4.37222 8.29547 4.48769 8.18C4.60317 8.06453 4.75978 7.99966 4.92308 7.99966C5.08638 7.99966 5.24299 8.06453 5.35846 8.18L6.76923 9.59154L10.6415 5.71846C10.6987 5.66124 10.7666 5.61585 10.8413 5.58489C10.916 5.55392 10.9961 5.53798 11.0769 5.53798C11.1578 5.53798 11.2379 5.55392 11.3126 5.58489C11.3873 5.61585 11.4552 5.66124 11.5123 5.71846ZM16 8C16 9.58225 15.5308 11.129 14.6518 12.4446C13.7727 13.7602 12.5233 14.7855 11.0615 15.391C9.59966 15.9965 7.99113 16.155 6.43928 15.8463C4.88743 15.5376 3.46197 14.7757 2.34315 13.6569C1.22433 12.538 0.462403 11.1126 0.153721 9.56072C-0.15496 8.00887 0.00346628 6.40034 0.608967 4.93853C1.21447 3.47672 2.23985 2.22729 3.55544 1.34824C4.87103 0.469192 6.41775 0 8 0C10.121 0.00223986 12.1546 0.845814 13.6544 2.34562C15.1542 3.84542 15.9978 5.87895 16 8ZM14.7692 8C14.7692 6.66117 14.3722 5.35241 13.6284 4.23922C12.8846 3.12602 11.8274 2.25839 10.5905 1.74605C9.35356 1.2337 7.99249 1.09965 6.67939 1.36084C5.36629 1.62203 4.16013 2.26674 3.21343 3.21343C2.26674 4.16012 1.62203 5.36629 1.36084 6.67939C1.09965 7.99249 1.2337 9.35356 1.74605 10.5905C2.2584 11.8274 3.12603 12.8846 4.23922 13.6284C5.35241 14.3722 6.66117 14.7692 8 14.7692C9.79469 14.7672 11.5153 14.0534 12.7843 12.7843C14.0534 11.5153 14.7672 9.79468 14.7692 8Z"
          fill="currentColor"
        />
      );
    case 'close':
    case 'x':
      return (
        <path
          d="M11.6458 11.6464L6.39937 6.4L6.40001 6.39935L11.6465 11.6458L12 11.9994L12.3536 11.6458L17.6 6.39935L17.6007 6.4L12.3542 11.6464L12.0007 12L12.3542 12.3535L17.6007 17.6L17.6 17.6006L12.3536 12.3542L12 12.0006L11.6465 12.3542L6.40001 17.6006L6.39937 17.6L11.6458 12.3535L11.9994 12L11.6458 11.6464Z"
          fill="currentColor"
          stroke="currentColor"
        />
      );
    case 'cart':
      return (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.3501 4.81233C10.7877 4.38367 11.3812 4.14286 12 4.14286C12.6188 4.14286 13.2123 4.38367 13.6499 4.81233C14.0875 5.24098 14.3333 5.82236 14.3333 6.42857L14.3333 7.57143H9.66667V6.42857C9.66667 5.82236 9.9125 5.24098 10.3501 4.81233ZM15.5 7.57143H19V19H5V7.57143H8.5V6.42857C8.5 5.51926 8.86875 4.64719 9.52513 4.0042C10.1815 3.36122 11.0717 3 12 3C12.9283 3 13.8185 3.36122 14.4749 4.00421C15.1313 4.64719 15.5 5.51926 15.5 6.42857L15.5 7.57143ZM14.3333 8.61039V11H15.5V8.61039H17.9231V17.961H6.07692V8.61039H8.5V11H9.66667V8.61039H14.3333Z"
          fill="currentColor"
        />
      );
    case 'heart':
    case 'favorite':
      return (
        <path
          d="M12 19.6537L11.2423 18.9692C9.61025 17.4782 8.26025 16.2019 7.19225 15.1404C6.12442 14.0787 5.2815 13.1425 4.6635 12.3317C4.0455 11.5208 3.61375 10.7872 3.36825 10.1307C3.12275 9.47432 3 8.81407 3 8.1499C3 6.87807 3.43208 5.81015 4.29625 4.94615C5.16025 4.08199 6.22817 3.6499 7.5 3.6499C8.3795 3.6499 9.2045 3.8749 9.975 4.3249C10.7455 4.7749 11.4205 5.4294 12 6.2884C12.5795 5.4294 13.2545 4.7749 14.025 4.3249C14.7955 3.8749 15.6205 3.6499 16.5 3.6499C17.7718 3.6499 18.8398 4.08199 19.7038 4.94615C20.5679 5.81015 21 6.87807 21 8.1499C21 8.81407 20.8773 9.47432 20.6318 10.1307C20.3863 10.7872 19.9545 11.5208 19.3365 12.3317C18.7185 13.1425 17.8787 14.0787 16.8173 15.1404C15.7558 16.2019 14.4026 17.4782 12.7578 18.9692L12 19.6537ZM12 18.2999C13.6 16.8537 14.9167 15.615 15.95 14.5837C16.9833 13.5522 17.8 12.6572 18.4 11.8989C19 11.1406 19.4167 10.4688 19.65 9.88365C19.8833 9.29832 20 8.7204 20 8.1499C20 7.1499 19.6667 6.31657 19 5.6499C18.3333 4.98324 17.5 4.6499 16.5 4.6499C15.7038 4.6499 14.9692 4.87715 14.2962 5.33165C13.6231 5.78615 13.0205 6.4704 12.4885 7.3844H11.5115C10.9667 6.45757 10.3609 5.77007 9.69425 5.3219C9.02758 4.8739 8.29617 4.6499 7.5 4.6499C6.51283 4.6499 5.68267 4.98324 5.0095 5.6499C4.3365 6.31657 4 7.1499 4 8.1499C4 8.7204 4.11667 9.29832 4.35 9.88365C4.58333 10.4688 5 11.1406 5.6 11.8989C6.2 12.6572 7.01667 13.5489 8.05 14.5739C9.08333 15.5989 10.4 16.8409 12 18.2999Z"
          fill="currentColor"
        />
      );
    case 'burger':
      return (
        <path
          d="M4 17.2692V16.2692H20V17.2692H4ZM4 12.5V11.5H20V12.5H4ZM4 7.73071V6.73071H20V7.73071H4Z"
          fill="currentColor"
        />
      );
    case 'arrowright':
      return (
        <path
          d="M17.0788 12.5H5V11.5H17.0788L11.2865 5.70775L12 5L19 12L12 19L11.2865 18.2923L17.0788 12.5Z"
          fill="currentColor"
        />
      );
    case 'tiktok':
      return (
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M20.0413 10.3828H20.0054C18.3541 10.3828 16.8463 9.89062 15.6258 9.01172V15.3047C15.6258 18.4688 13.0052 21 9.77427 21C6.54338 21 3.95866 18.4688 3.95866 15.3047C3.95866 12.1406 6.54338 9.57422 9.77427 9.57422C10.0615 9.57422 10.3128 9.60938 10.5999 9.64453V12.8086C10.3128 12.7031 10.0615 12.668 9.77427 12.668C8.30242 12.668 7.08186 13.8633 7.08186 15.3047C7.08186 16.7461 8.30242 17.9414 9.77427 17.9414C11.2461 17.9414 12.4667 16.7461 12.4667 15.3047V3H15.6258C15.6258 3.03516 15.6258 3.03516 15.6258 3.07031C15.6258 3.31641 15.6258 3.5625 15.6976 3.80859C15.913 4.96875 16.6309 5.98828 17.6361 6.62109C18.3182 7.07812 19.1439 7.32422 20.0054 7.32422C20.0054 7.32422 20.0054 7.32422 20.0413 7.32422V10.3828Z"
          fill="currentColor"
        />
      );
    case 'youtube':
      return (
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M21.3875 7.39453C21.8183 8.87109 21.8183 12.0352 21.8183 12.0352C21.8183 12.0352 21.8183 15.1641 21.3875 16.6758C21.1721 17.5195 20.4901 18.1523 19.6644 18.3633C18.1207 18.75 12.018 18.75 12.018 18.75C12.018 18.75 5.87925 18.75 4.3356 18.3633C3.50993 18.1523 2.82785 17.5195 2.61246 16.6758C2.18167 15.1641 2.18167 12.0352 2.18167 12.0352C2.18167 12.0352 2.18167 8.87109 2.61246 7.39453C2.82785 6.55078 3.50993 5.88281 4.3356 5.67188C5.87925 5.25 12.018 5.25 12.018 5.25C12.018 5.25 18.1207 5.25 19.6644 5.67188C20.4901 5.88281 21.1721 6.55078 21.3875 7.39453ZM10.0076 14.8828L15.1052 12.0352L10.0076 9.1875V14.8828Z"
          fill="currentColor"
        />
      );
    case 'facebook':
      return (
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M20.9029 12.0527C20.9029 16.4121 17.6361 20.0332 13.3642 20.666V14.584H15.4463L15.8412 12.0527H13.3642V10.4355C13.3642 9.73242 13.7231 9.06445 14.836 9.06445H15.9489V6.91992C15.9489 6.91992 14.9437 6.74414 13.9385 6.74414C11.9282 6.74414 10.5999 7.97461 10.5999 10.1543V12.0527H8.33832V14.584H10.5999V20.666C6.32799 20.0332 3.09709 16.4121 3.09709 12.0527C3.09709 7.23633 7.08186 3.33398 12 3.33398C16.9181 3.33398 20.9029 7.23633 20.9029 12.0527Z"
          fill="currentColor"
        />
      );
    case 'instagram':
      return (
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M12.0183 7.93945C14.3255 7.93945 16.2299 9.76758 16.2299 11.9824C16.2299 14.2324 14.3255 16.0254 12.0183 16.0254C9.67445 16.0254 7.80668 14.2324 7.80668 11.9824C7.80668 9.76758 9.67445 7.93945 12.0183 7.93945ZM12.0183 14.6191C13.5198 14.6191 14.7284 13.459 14.7284 11.9824C14.7284 10.541 13.5198 9.38086 12.0183 9.38086C10.4801 9.38086 9.27159 10.541 9.27159 11.9824C9.27159 13.459 10.5168 14.6191 12.0183 14.6191ZM17.3652 7.79883C17.3652 8.32617 16.9258 8.74805 16.3764 8.74805C15.8271 8.74805 15.3876 8.32617 15.3876 7.79883C15.3876 7.27148 15.8271 6.84961 16.3764 6.84961C16.9258 6.84961 17.3652 7.27148 17.3652 7.79883ZM20.1486 8.74805C20.2218 10.0488 20.2218 13.9512 20.1486 15.252C20.0753 16.5176 19.7824 17.6074 18.8302 18.5566C17.878 19.4707 16.706 19.752 15.3876 19.8223C14.0326 19.8926 9.96743 19.8926 8.61238 19.8223C7.29396 19.752 6.15865 19.4707 5.16984 18.5566C4.21764 17.6074 3.92466 16.5176 3.85141 15.252C3.77817 13.9512 3.77817 10.0488 3.85141 8.74805C3.92466 7.48242 4.21764 6.35742 5.16984 5.44336C6.15865 4.5293 7.29396 4.24805 8.61238 4.17773C9.96743 4.10742 14.0326 4.10742 15.3876 4.17773C16.706 4.24805 17.878 4.5293 18.8302 5.44336C19.7824 6.35742 20.0753 7.48242 20.1486 8.74805ZM18.3907 16.623C18.8302 15.6035 18.7203 13.1426 18.7203 11.9824C18.7203 10.8574 18.8302 8.39648 18.3907 7.3418C18.0977 6.67383 17.5484 6.11133 16.8525 5.86523C15.7538 5.44336 13.1902 5.54883 12.0183 5.54883C10.8098 5.54883 8.24615 5.44336 7.18409 5.86523C6.45164 6.14648 5.90229 6.67383 5.60931 7.3418C5.16984 8.39648 5.2797 10.8574 5.2797 11.9824C5.2797 13.1426 5.16984 15.6035 5.60931 16.623C5.90229 17.3262 6.45164 17.8535 7.18409 18.1348C8.24615 18.5566 10.8098 18.4512 12.0183 18.4512C13.1902 18.4512 15.7538 18.5566 16.8525 18.1348C17.5484 17.8535 18.1343 17.3262 18.3907 16.623Z"
          fill="currentColor"
        />
      );
    case 'twitter':
      return (
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M19.1543 8.32617C19.1543 8.50195 19.1543 8.64258 19.1543 8.81836C19.1543 13.7051 15.4629 19.2949 8.67773 19.2949C6.56836 19.2949 4.63477 18.6973 3.01758 17.6426C3.29883 17.6777 3.58008 17.7129 3.89648 17.7129C5.61914 17.7129 7.20117 17.1152 8.4668 16.1309C6.84961 16.0957 5.47852 15.041 5.02148 13.5645C5.26758 13.5996 5.47852 13.6348 5.72461 13.6348C6.04102 13.6348 6.39258 13.5645 6.67383 13.4941C4.98633 13.1426 3.7207 11.666 3.7207 9.87305V9.83789C4.21289 10.1191 4.81055 10.2598 5.4082 10.2949C4.38867 9.62695 3.75586 8.50195 3.75586 7.23633C3.75586 6.5332 3.93164 5.90039 4.24805 5.37305C6.07617 7.58789 8.81836 9.06445 11.877 9.24023C11.8066 8.95898 11.7715 8.67773 11.7715 8.39648C11.7715 6.35742 13.4238 4.70508 15.4629 4.70508C16.5176 4.70508 17.4668 5.12695 18.1699 5.86523C18.9785 5.68945 19.7871 5.37305 20.4902 4.95117C20.209 5.83008 19.6465 6.5332 18.873 6.99023C19.6113 6.91992 20.3496 6.70898 20.9824 6.42773C20.4902 7.16602 19.8574 7.79883 19.1543 8.32617Z"
          fill="currentColor"
        />
      );
    case 'pinterest':
      return (
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M20.9029 12C20.9029 16.8164 16.9181 20.7188 12 20.7188C11.0666 20.7188 10.1692 20.6133 9.34349 20.332C9.70247 19.7695 10.241 18.8203 10.4563 18.0469C10.564 17.6602 10.9948 15.9727 10.9948 15.9727C11.282 16.5352 12.1436 16.9922 13.0411 16.9922C15.7335 16.9922 17.672 14.5664 17.672 11.5781C17.672 8.69531 15.2668 6.51562 12.1795 6.51562C8.33832 6.51562 6.29209 9.04688 6.29209 11.7891C6.29209 13.0898 6.97416 14.6719 8.08703 15.1992C8.26652 15.2695 8.37422 15.2344 8.41012 15.0586C8.41012 14.9531 8.58961 14.3555 8.66141 14.0742C8.66141 14.0039 8.66141 13.8984 8.58961 13.8281C8.23062 13.4062 7.94343 12.5977 7.94343 11.8242C7.94343 9.92578 9.41528 8.0625 11.9641 8.0625C14.118 8.0625 15.6617 9.50391 15.6617 11.6133C15.6617 13.9688 14.4411 15.5859 12.8616 15.5859C12 15.5859 11.3538 14.8828 11.5333 14.0391C11.7846 12.9844 12.2872 11.8594 12.2872 11.1211C12.2872 10.4531 11.9282 9.89062 11.1743 9.89062C10.2769 9.89062 9.55888 10.8047 9.55888 12C9.55888 12.7734 9.81017 13.3008 9.81017 13.3008C9.81017 13.3008 8.9486 16.957 8.7691 17.625C8.58961 18.3984 8.66141 19.4531 8.73321 20.1211C5.43051 18.8555 3.09709 15.7266 3.09709 12C3.09709 7.18359 7.08186 3.28125 12 3.28125C16.9181 3.28125 20.9029 7.18359 20.9029 12Z"
          fill="currentColor"
        />
      );
    case 'person':
      return (
        <path
          fill="currentColor"
          d="M17.65 5C18.3953 5 19 5.58789 19 6.3125V17.6875C19 18.4121 18.3953 19 17.65 19H6.35C5.60469 19 5 18.4121 5 17.6875V6.3125C5 5.58789 5.60469 5 6.35 5H17.65ZM17.65 17.6875V6.3125H6.35V17.6875H17.65ZM12 12C11.0072 12 10.2 11.2152 10.2 10.25C10.2 9.28477 11.0072 8.5 12 8.5C12.9928 8.5 13.8 9.28477 13.8 10.25C13.8 11.2152 12.9928 12 12 12ZM9.48001 15.5C9.13125 15.5 8.85 15.2649 8.85 14.975V14.45C8.85 13.5805 9.69655 12.875 10.74 12.875H10.8806C11.2238 13.0144 11.6034 13.0938 12 13.0938C12.3966 13.0938 12.7734 13.0144 13.1194 12.875H13.26C14.3034 12.875 15.15 13.5805 15.15 14.45V14.975C15.15 15.2649 14.8687 15.5 14.52 15.5H9.48001Z"
        />
      );
    case 'search':
      return (
        <path
          d="M12.8833 11.2969L9.85986 8.27344C9.81299 8.22656 9.74268 8.20312 9.67236 8.20312H9.41455C10.2349 7.3125 10.7271 6.16406 10.7271 4.875C10.7271 2.20312 8.52393 0 5.85205 0C3.15674 0 0.977051 2.20312 0.977051 4.875C0.977051 7.57031 3.15674 9.75 5.85205 9.75C7.11768 9.75 8.28955 9.25781 9.15674 8.46094V8.69531C9.15674 8.78906 9.18018 8.85938 9.22705 8.90625L12.2505 11.9297C12.3677 12.0469 12.5317 12.0469 12.6489 11.9297L12.8833 11.6953C13.0005 11.5781 13.0005 11.4141 12.8833 11.2969ZM5.85205 9C3.55518 9 1.72705 7.17188 1.72705 4.875C1.72705 2.60156 3.55518 0.75 5.85205 0.75C8.12549 0.75 9.97705 2.60156 9.97705 4.875C9.97705 7.17188 8.12549 9 5.85205 9Z"
          fill="currentColor"
        />
      );
    case 'star':
      return (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.52229 1.54573C5.66749 1.07591 6.33251 1.07591 6.47771 1.54572L7.3076 4.23103C7.37235 4.44053 7.56604 4.5834 7.78531 4.5834H10.5219C11.0002 4.5834 11.2055 5.19037 10.8255 5.48071L8.56865 7.20487C8.40214 7.33208 8.33261 7.54962 8.39448 7.74983L9.24607 10.5053C9.38982 10.9704 8.85168 11.3458 8.46483 11.0503L6.30351 9.39918C6.12432 9.26229 5.87567 9.26228 5.69647 9.39916L3.53459 11.0505C3.14773 11.346 2.60964 10.9706 2.75337 10.5055L3.60503 7.7498C3.66689 7.54961 3.59738 7.33208 3.43089 7.20487L1.17435 5.48069C0.79434 5.19034 0.999677 4.5834 1.47792 4.5834H4.21469C4.43397 4.5834 4.62765 4.44053 4.6924 4.23103L5.52229 1.54573Z"
          fill="currentColor"
        />
      );
    case 'starOutline':
      return (
        <path
          d="M5.76115 1.61954C5.83375 1.38463 6.16625 1.38463 6.23885 1.61954L7.06875 4.30485C7.16587 4.61909 7.4564 4.8334 7.78531 4.8334H10.5219C10.7611 4.8334 10.8637 5.13688 10.6737 5.28205L8.41687 7.00621C8.16711 7.19703 8.06282 7.52334 8.15563 7.82364L9.00722 10.5792C9.07909 10.8117 8.81003 10.9994 8.6166 10.8516L6.45528 9.20052C6.18649 8.99518 5.81352 8.99517 5.54472 9.20049L3.38283 10.8518C3.18941 10.9996 2.92036 10.8119 2.99223 10.5793L3.84388 7.82362C3.93668 7.52334 3.83241 7.19704 3.58267 7.00622L1.32614 5.28204C1.13613 5.13687 1.2388 4.8334 1.47792 4.8334H4.21469C4.5436 4.8334 4.83413 4.61909 4.93125 4.30485L5.76115 1.61954Z"
          stroke="currentColor"
          strokeWidth="0.5"
        />
      );
    case 'trashcan':
      return (
        <g>
          <path
            d="M7.6155 20.0002C7.168 20.0002 6.78683 19.8429 6.472 19.5282C6.15733 19.2134 6 18.8322 6 18.3847V6.00021H5V5.00021H9V4.23096H15V5.00021H19V6.00021H18V18.3847C18 18.845 17.8458 19.2294 17.5375 19.5377C17.2292 19.846 16.8448 20.0002 16.3845 20.0002H7.6155ZM17 6.00021H7V18.3847C7 18.5642 7.05767 18.7117 7.173 18.8272C7.2885 18.9425 7.436 19.0002 7.6155 19.0002H16.3845C16.5385 19.0002 16.6796 18.9361 16.8077 18.808C16.9359 18.6798 17 18.5387 17 18.3847V6.00021ZM9.80775 17.0002H10.8078V8.00021H9.80775V17.0002ZM13.1923 17.0002H14.1923V8.00021H13.1923V17.0002Z"
            fill="currentColor"
          />
        </g>
      );
    case 'email':
      return (
        <>
          <path
            d="M28.9795 24.1807H3.01953V7.82031H28.9795V24.1807ZM16.333 19.8926L16 20.1924L15.666 19.8926L12.1553 16.7432L4.84375 23.1807H27.1553L19.8428 16.7432L16.333 19.8926ZM4.01953 22.5732L11.4062 16.0703L4.01953 9.44043V22.5732ZM20.5918 16.0703L27.9795 22.5732V9.44043L20.5918 16.0703ZM12.4932 15.7021L15.999 18.8486L19.5059 15.7021L27.1738 8.82031H4.8252L12.4932 15.7021Z"
            fill="currentColor"
          />
        </>
      );
    case 'checkoutLoadingIndicator':
      /** This returns a fragment because Savage utilizes a gif from the CDN for their checkout
       * loading indicator. If Savage decides to switch to a custom built loading indicator in-code
       * it should be returned here.
       */
      return <></>;
    default:
      return null;
  }
};

export const SavageIcons = (props: Props) => {
  const { type, ...otherProps } = props;
  const viewBox = VIEWBOX[type as keyof typeof VIEWBOX];
  const additionalProps =
    ADDITIONAL_PROPS[type as keyof typeof ADDITIONAL_PROPS] ?? EMPTY_PROPS;

  return (
    <IconBase viewBox={viewBox} {...otherProps} {...additionalProps}>
      <Path {...props} />
    </IconBase>
  );
};
